module.exports = __webpack_public_path__ + "static/media/orkids.953ae94e.png";